<table class="accordion-table">
    <thead>
        <tr>
            <th>#</th>
            <th>{{ 'REQUEST_DETAIL.CONCEPT' | translate }}</th>
            <th>{{ 'REQUEST_DETAIL.RULE' | translate }}</th>
            <th class="center">{{ 'REQUEST_DETAIL.STATUS' | translate }}</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let r of feasibilityRules; let i = index" [ngClass]="{ 'not-feasible': !r.isFeasible, 'feasible': r.isFeasible  }">
            <td>{{ i + 1 }}</td>
            <td>{{ freelancerRequestDetailFeasibilityService.translateRuleConcept(r) | async }}</td>
            <td>{{ freelancerRequestDetailFeasibilityService.translateRuleDescription(r) | async }}</td>
            <td class="center">
                <span class="line-result" [class.pass]="r.isFeasible">
                    <span class="material-symbols-outlined">
                        {{ r.isFeasible ? 'check_small' : 'exclamation' }}
                    </span>
                </span>
            </td>
        </tr>
    </tbody>
</table>
